import {forwardRef, useEffect, useState} from 'react';
import {Input as LuffyInput, InputProps as LuffyInputProps} from '@baidu/luffy-comp-input';

export {InputWrapper} from '@baidu/luffy-comp-input';
export declare class InputRef extends LuffyInput {}

export interface InputProps extends LuffyInputProps {
    onMaxLengthError?: (isError: boolean) => void;
}

const Input = forwardRef<LuffyInput, InputProps>((props: InputProps, ref) => {
    const {
        children, status,
        maxLength, defaultValue = '', value,
        onChange, onMaxLengthError,
        ...inputProps
    } = props;

    const inputMaxLength = maxLength;
    const [inputStatus, setInputStatus] = useState(status || 'normal');
    const [inputValue, setInputValue] = useState(value || defaultValue);

    useEffect(() => {
        if (onMaxLengthError) {
            onMaxLengthError(inputStatus === 'error'
                && !!maxLength && inputValue.toString().length >= maxLength
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputStatus]);

    useEffect(() => {
        let s = status;
        const str = (onChange ? value : inputValue) || '';
        if (!!maxLength && str.toString().length >= maxLength) {
            s = 'error';
        } else {
            s = (status || 'normal');
        }
        if (s !== inputStatus) {
            setInputStatus(s);
        }
    }, [maxLength, inputValue, onChange, value, status, inputStatus]);

    function handleChange(e: React.FocusEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>) {
        const str = e.target.value;
        if (onChange) {
            onChange(e);
            return;
        }
        setInputValue(str);
    }

    return (
        <LuffyInput
            status={inputStatus}
            maxLength={inputMaxLength}
            value={onChange ? value : inputValue}
            onChange={handleChange}
            {...inputProps}
            ref={ref}
        >
            {children}
        </LuffyInput>
    );
});

export default Input;
